import { apiSlice } from "../api/apiSlice";

export const assignmentsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => `/my/assignments`,
      providesTags: (result, error, arg) => [{ type: "Assignment" }],
    }),
    getAssignment: builder.query({
      query: ({ assignmentId }) => `/assignments/${assignmentId}`,
      providesTags: (result, error, arg) => [
        { type: "Assignment", id: `${arg?.assignmentId}` },
      ],
    }),
  }),
});

export const { useGetAssignmentsQuery, useGetAssignmentQuery } =
  assignmentsSlice;
